/**
 * Arc-style Typography utilities
 * 
 * These classes replace Material Tailwind's Typography component.
 * Use these as className values or import the component variants.
 */

// Heading styles
export const headingStyles = {
  h1: "text-arc-4xl font-bold text-content-primary tracking-tight",
  h2: "text-arc-3xl font-bold text-content-primary tracking-tight",
  h3: "text-arc-2xl font-semibold text-content-primary",
  h4: "text-arc-xl font-semibold text-content-primary",
  h5: "text-arc-lg font-semibold text-content-primary",
  h6: "text-arc-base font-semibold text-content-primary",
};

// Body text styles
export const bodyStyles = {
  large: "text-arc-lg text-content-primary leading-relaxed",
  base: "text-arc-base text-content-primary leading-relaxed",
  small: "text-arc-sm text-content-secondary leading-relaxed",
  xs: "text-arc-xs text-content-tertiary leading-relaxed",
};

// Label styles
export const labelStyles = {
  large: "text-arc-sm font-semibold text-content-primary",
  base: "text-arc-sm font-medium text-content-primary",
  small: "text-arc-xs font-medium text-content-secondary",
};

// Caption/helper text styles
export const captionStyles = {
  base: "text-arc-xs text-content-tertiary",
  error: "text-arc-xs text-error-main",
  success: "text-arc-xs text-success-dark",
};

// Display styles (for hero sections, etc.)
export const displayStyles = {
  large: "text-5xl font-bold text-content-primary tracking-tight",
  base: "text-4xl font-bold text-content-primary tracking-tight",
  small: "text-3xl font-bold text-content-primary tracking-tight",
};

// Link styles
export const linkStyles = {
  base: "text-accent hover:text-accent-light transition-colors duration-arc-fast cursor-pointer underline-offset-2 hover:underline",
  subtle: "text-content-secondary hover:text-content-primary transition-colors duration-arc-fast cursor-pointer",
  muted: "text-content-tertiary hover:text-content-secondary transition-colors duration-arc-fast cursor-pointer",
};

// Paragraph styles
export const paragraphStyles = {
  lead: "text-arc-lg text-content-secondary leading-relaxed",
  base: "text-arc-base text-content-secondary leading-relaxed",
  small: "text-arc-sm text-content-secondary leading-relaxed",
};

// Code/monospace styles
export const codeStyles = {
  inline: "font-mono text-arc-sm bg-surface-tertiary text-content-primary px-1.5 py-0.5 rounded-arc-sm",
  block: "font-mono text-arc-sm bg-surface-tertiary text-content-primary p-4 rounded-arc-md overflow-x-auto",
};

// Utility function to combine typography classes
export const typography = {
  heading: headingStyles,
  body: bodyStyles,
  label: labelStyles,
  caption: captionStyles,
  display: displayStyles,
  link: linkStyles,
  paragraph: paragraphStyles,
  code: codeStyles,
};

export default typography;









